import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { GET_QUERY_INITIALIZE, GET_QUERY_LIST_RESULT, ADD_OBJECT_ATTEMPT, ADD_OBJECT_TWO_STEP_ATTEMPT, ADD_FILE_ATTEMPT, GET_BY_POST_OBJECT_ATTEMPT, ADD_OBJECT_DATAPOOL_ATTEMPT, ADD_FILE_DATAPOOL_ATTEMPT } from '../Actions/LogisticActions'
import { GET_REQUEST_PARAMETER_API, ADD_REQUEST_BODY_API, ADD_REQUEST_FILE_API, GET_REQUEST_BODY_API, GET_REQUEST_DATA_POOL_PARAMETER_API } from '../Services/API'
import { UNAUTHORIZED_CASE, UNAUTHORIZED_HTTP_CODE } from '../Actions/AuthorizationActions'



function* GeneralPost_Saga(action) {
    console.log(action)
    const  Result = yield call(ADD_REQUEST_BODY_API, action.Container.AddPath, action.Container.Body)

    if(Result.Code == UNAUTHORIZED_HTTP_CODE){
        yield put({
            type:UNAUTHORIZED_CASE
        })

        return
    }
    
    if(Result.Code != 200) {
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.AddParameter]: false,
                [action.Container.AddErrorParameter]: Result.message,
                GeneralError:Result.message,
                AddedSuccessfuly: false
            }
        })
    }
    else{
        if(action.Container.OnSuccess){
            
            action.Container.OnSuccess()
        }

        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.AddParameter]: false,
                [action.Container.AddErrorParameter]: '',
                GeneralError: '',
                AddedSuccessfuly: true,
                [action.Container.SearchParameter]: true,
                [action.Container.DataParameter]: []
            }
        })

        
    }

    if(action.Container.GetPath){
        const  Result_2 = yield call(GET_REQUEST_PARAMETER_API, action.Container.GetPath, action.Container.Value)
    
        if(Result_2.Code == UNAUTHORIZED_HTTP_CODE){
            yield put({
                type:UNAUTHORIZED_CASE
            })
    
            return
        }

        if(Result_2.Code == 200){
            yield put({
                type:GET_QUERY_LIST_RESULT,
                Container:{
                    [action.Container.SearchParameter]: false,
                    [action.Container.DataParameter]: Result_2.data.data,
                    [action.Container.GetErrorParameter]: ''
                }
            })
        }
        else{
            yield put({
                type:GET_QUERY_LIST_RESULT,
                Container:{
                    [action.Container.SearchParameter]: false,
                    [action.Container.GetErrorParameter]: Result_2.message
                }
            })
        }    
}
}

function* GeneralPostDataPool_Saga(action) {
    console.log(action)
    const  Result = yield call(ADD_REQUEST_BODY_API, action.Container.AddPath, action.Container.Body)

    if(Result.Code == UNAUTHORIZED_HTTP_CODE){
        yield put({
            type:UNAUTHORIZED_CASE
        })

        return
    }
    
    if(Result.Code != 200) {
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.AddParameter]: false,
                [action.Container.AddErrorParameter]: Result.message,
                GeneralError:Result.message,
                AddedSuccessfuly: false
            }
        })
    }
    else{
        if(action.Container.OnSuccess){
            
            action.Container.OnSuccess()
        }

        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.AddParameter]: false,
                [action.Container.AddErrorParameter]: '',
                GeneralError: '',
                AddedSuccessfuly: true,
                [action.Container.SearchParameter]: true,
                [action.Container.DataParameter]: []
            }
        })

        
    }

    if(action.Container.GetPath){
        const  Result_2 = yield call(GET_REQUEST_DATA_POOL_PARAMETER_API, action.Container.GetPath, action.Container.Value)
    
        if(Result_2.Code == UNAUTHORIZED_HTTP_CODE){
            yield put({
                type:UNAUTHORIZED_CASE
            })
    
            return
        }

        if(Result_2.Code == 200){
            yield put({
                type:GET_QUERY_LIST_RESULT,
                Container:{
                    [action.Container.SearchParameter]: false,
                    [action.Container.DataParameter]: Result_2.data.data,
                    [action.Container.GetErrorParameter]: ''
                }
            })
        }
        else{
            yield put({
                type:GET_QUERY_LIST_RESULT,
                Container:{
                    [action.Container.SearchParameter]: false,
                    [action.Container.GetErrorParameter]: Result_2.message
                }
            })
        }    
}
}

function* GeneralFilePost_Saga(action) {
    let Result = yield call(ADD_REQUEST_FILE_API, action.Container.AddPath,  action.Container.Body)
    
    console.log(Result)

    if(Result.Code == UNAUTHORIZED_HTTP_CODE){
        yield put({
            type:UNAUTHORIZED_CASE
        })

        return
    }

    if(Result.Code != 200) {
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.AddParameter]: false,
                [action.Container.AddErrorParameter]: Result.message,
                GeneralError: Result.message,
                AddedSuccessfuly: false
            }
        })
    }
    else{
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.AddParameter]: false,
                [action.Container.AddErrorParameter]: '',
                GeneralError: '',
                AddedSuccessfuly: true,
            }
        })

        if(action.Container.OnSuccess){
            
            action.Container.OnSuccess()
        }
    }

    if(action.Container.GetPath){
        const  Result_2 = yield call(action.Container.GetByPost ? GET_REQUEST_BODY_API : GET_REQUEST_PARAMETER_API, action.Container.GetPath, action.Container.Value)
    
        if(Result_2.Code == UNAUTHORIZED_HTTP_CODE){
            yield put({
                type:UNAUTHORIZED_CASE
            })
    
            return
        }

        if(Result_2.Code == 200){
            yield put({
                type:GET_QUERY_LIST_RESULT,
                Container:{
                    [action.Container.SearchParameter]: false,
                    [action.Container.DataParameter]: Result_2.data.data,
                    [action.Container.GetErrorParameter]: ''
                }
            })
        }
        else{
            yield put({
                type:GET_QUERY_LIST_RESULT,
                Container:{
                    [action.Container.SearchParameter]: false,
                    [action.Container.GetErrorParameter]: Result_2.message
                }
            })
        }   
    }

}

function* GeneralFilePostDataPool_Saga(action) {
    let Result = yield call(ADD_REQUEST_FILE_API, action.Container.AddPath,  action.Container.Body)
    
    console.log(Result)

    if(Result.Code == UNAUTHORIZED_HTTP_CODE){
        yield put({
            type:UNAUTHORIZED_CASE
        })

        return
    }

    if(Result.Code != 200) {
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.AddParameter]: false,
                [action.Container.AddErrorParameter]: Result.message,
                GeneralError: Result.message,
                AddedSuccessfuly: false
            }
        })
    }
    else{
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.AddParameter]: false,
                [action.Container.AddErrorParameter]: '',
                GeneralError: '',
                AddedSuccessfuly: true,
            }
        })

        if(action.Container.OnSuccess){
            
            action.Container.OnSuccess()
        }
    }

    if(action.Container.GetPath){
        const  Result_2 = yield call(action.Container.GetByPost ? GET_REQUEST_BODY_API : GET_REQUEST_DATA_POOL_PARAMETER_API, action.Container.GetPath, action.Container.Value)
    
        if(Result_2.Code == UNAUTHORIZED_HTTP_CODE){
            yield put({
                type:UNAUTHORIZED_CASE
            })
    
            return
        }

        if(Result_2.Code == 200){
            yield put({
                type:GET_QUERY_LIST_RESULT,
                Container:{
                    [action.Container.SearchParameter]: false,
                    [action.Container.DataParameter]: Result_2.data.data,
                    [action.Container.GetErrorParameter]: ''
                }
            })
        }
        else{
            yield put({
                type:GET_QUERY_LIST_RESULT,
                Container:{
                    [action.Container.SearchParameter]: false,
                    [action.Container.GetErrorParameter]: Result_2.message
                }
            })
        }   
    }

}

function* GeneralTwoStepPost_Saga(action) {
    let  Result = yield call(ADD_REQUEST_BODY_API, action.Container.AddPath1, action.Container.Body.Info)

    if(Result.Code == UNAUTHORIZED_HTTP_CODE){
        yield put({
            type:UNAUTHORIZED_CASE
        })

        return
    }

    if(Result.Code == 200){
        let data = action.Container.Body.File
        data.append(action.Container.Body.Id, Result.data.data.Id)

        Result = yield call(ADD_REQUEST_FILE_API, action.Container.AddPath2, data)

        if(Result.Code == 200){
            yield put({
                type:GET_QUERY_LIST_RESULT,
                Container:{
                    [action.Container.AddParameter]: false,
                    AddedSuccessfuly: true,
                    [action.Container.AddErrorParameter]: '',
                    GeneralError: ''

                }
            })
        }
        else{
            yield put({
                type:GET_QUERY_LIST_RESULT,
                Container:{
                    [action.Container.AddParameter]: false,
                    [action.Container.AddErrorParameter]: Result.message,
                    GeneralError: Result.message,
                    AddedSuccessfuly: false
                }
            })
        }

    }
    else{
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.AddParameter]: false,
                [action.Container.AddErrorParameter]: Result.message,
                GeneralError: Result.message,
                AddedSuccessfuly: false
            }
        })
    }

    if(action.Container.GetPath){
        const  Result_2 = yield call(GET_REQUEST_PARAMETER_API, action.Container.GetPath, action.Container.Value)

        if(Result_2.Code == UNAUTHORIZED_HTTP_CODE){
            yield put({
                type:UNAUTHORIZED_CASE
            })
    
            return
        }

        if(Result_2.Code == 200){
            yield put({
                type:GET_QUERY_LIST_RESULT,
                Container:{
                    [action.Container.SearchParameter]: false,
                    [action.Container.DataParameter]: Result_2.data.data,
                    [action.Container.GetErrorParameter]: ''
                }
            })
        }   
        else{
            yield put({
                type:GET_QUERY_LIST_RESULT,
                Container:{
                    [action.Container.SearchParameter]: false,
                    [action.Container.GetErrorParameter]: Result_2.message

                }
            })
        }     
}
}

function* GeneralGetByPost_Saga(action) {
    let Result = yield call(ADD_REQUEST_BODY_API, action.Container.Path,  action.Container.Body)

    if(Result.Code == UNAUTHORIZED_HTTP_CODE){
        yield put({
            type:UNAUTHORIZED_CASE
        })

        return
    }

    if(Result.Code == 200){
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.SearchParameter]: false,
                [action.Container.DataParameter]: Result.data.data,
                [action.Container.GetErrorParameter]: '',
                GeneralError: '',
            }
        })
    }
    else{
        yield put({
            type:GET_QUERY_LIST_RESULT,
            Container:{
                [action.Container.SearchParameter]: false,
                [action.Container.GetErrorParameter]: Result.message,
                GeneralError:Result.message,

            }
        })
    }   
    
}


export default function* GeneralPostSaga(){
    yield takeLatest(ADD_OBJECT_ATTEMPT, GeneralPost_Saga)
    yield takeLatest(ADD_OBJECT_DATAPOOL_ATTEMPT, GeneralPostDataPool_Saga)
    yield takeLatest(ADD_OBJECT_TWO_STEP_ATTEMPT, GeneralTwoStepPost_Saga)

    yield takeLatest(ADD_FILE_ATTEMPT, GeneralFilePost_Saga)
    yield takeLatest(ADD_FILE_DATAPOOL_ATTEMPT, GeneralFilePostDataPool_Saga)

    yield takeLatest(GET_BY_POST_OBJECT_ATTEMPT, GeneralGetByPost_Saga)

}